
import { callServer } from 'next/dist/client/app-call-server'

function __build_action__(action, args) {
  return callServer(action.$$id, args)
}

/* __next_internal_action_entry_do_not_use__ {"109de98bc3e0667424b21f82035306183442e629":"$$ACTION_0","24d0693b6a5a427679d6c4f2d8dc9a09a17e093d":"checkAccountExistsAction"} */ export var checkAccountExistsAction = createServerReference("24d0693b6a5a427679d6c4f2d8dc9a09a17e093d");
import { createServerReference } from "private-next-rsc-action-client-wrapper";

